import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Facebook, Linkedin, Youtube, ArrowRight } from "lucide-react";
import { API } from "@/App";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const subscribe = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      await axios.post(`${API}/newsletter`, { email });
      toast.success("You're on the list. Welcome aboard.");
      setEmail("");
    } catch {
      toast.error("Could not subscribe. Try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <footer data-testid="footer" className="bg-[#050505] border-t border-[#262626] pt-20 pb-10">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-16">
          <div className="lg:col-span-5">
            <div className="font-display text-4xl md:text-5xl text-white leading-tight">
              Stay in the<br />
              <span className="text-[#EC1985]">Gary Zelesky</span> loop.
            </div>
            <p className="mt-4 text-white/70 max-w-md">
              Occasional notes on passion, leadership, and resilience — direct from Gary. No spam, ever.
            </p>
          </div>

          <div className="lg:col-span-7">
            <form onSubmit={subscribe} data-testid="newsletter-form" className="flex flex-col sm:flex-row gap-3">
              <input
                data-testid="newsletter-email"
                type="email"
                required
                placeholder="your@email.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="input-base flex-1"
              />
              <button
                data-testid="newsletter-submit"
                type="submit"
                disabled={loading}
                className="btn-primary disabled:opacity-50"
              >
                {loading ? "..." : <>Subscribe <ArrowRight size={16} /></>}
              </button>
            </form>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 py-12 border-t border-[#262626]">
          <div>
            <div className="text-xs uppercase tracking-[0.25em] font-bold text-[#EC1985] mb-4">Explore</div>
            <ul className="space-y-2 text-white/80">
              <li><a href="#about" className="hover:text-white under-link">About</a></li>
              <li><a href="#speaking" className="hover:text-white under-link">Speaking</a></li>
              <li><a href="#industries" className="hover:text-white under-link">Industries</a></li>
              <li><a href="#books" className="hover:text-white under-link">Books</a></li>
            </ul>
          </div>
          <div>
            <div className="text-xs uppercase tracking-[0.25em] font-bold text-[#EC1985] mb-4">Keynotes</div>
            <ul className="space-y-2 text-white/80">
              <li>The Passion Centered Person</li>
              <li>Cause for Applause</li>
              <li>Life on the Ledge</li>
              <li>Game On!</li>
            </ul>
          </div>
          <div>
            <div className="text-xs uppercase tracking-[0.25em] font-bold text-[#EC1985] mb-4">Contact</div>
            <ul className="space-y-2 text-white/80">
              <li>
                <a
                  href="mailto:Cherisse@GaryZelesky.com"
                  className="hover:text-white under-link"
                  data-testid="footer-email"
                >
                  Cherisse@GaryZelesky.com
                </a>
              </li>
              <li><a href="#book" className="hover:text-white under-link">Book Gary</a></li>
            </ul>
          </div>
          <div>
            <div className="text-xs uppercase tracking-[0.25em] font-bold text-[#EC1985] mb-4">Follow</div>
            <div className="flex items-center gap-4 text-white/70">
              <a
                href="https://www.facebook.com/garyzeleskynow/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
                data-testid="social-facebook"
                className="hover:text-[#EC1985] transition-colors"
              >
                <Facebook size={20} />
              </a>
              <a
                href="https://www.linkedin.com/in/gary-zelesky-19095815/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
                data-testid="social-linkedin"
                className="hover:text-[#EC1985] transition-colors"
              >
                <Linkedin size={20} />
              </a>
              <a
                href="https://www.youtube.com/@garyzelesky8879"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="YouTube"
                data-testid="social-youtube"
                className="hover:text-[#EC1985] transition-colors"
              >
                <Youtube size={20} />
              </a>
            </div>
          </div>
        </div>

        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 pt-8 border-t border-[#262626]">
          <div className="font-display text-3xl md:text-4xl">
            GARY<span className="text-[#EC1985]">.</span>ZELESKY
          </div>
          <div className="text-xs uppercase tracking-[0.25em] text-white/50">
            © {new Date().getFullYear()} Gary Zelesky Presentations · All Rights Reserved
          </div>
        </div>
      </div>
    </footer>
  );
}
